// extracted by mini-css-extract-plugin
module.exports = {"ClientBox":"ClientsBox_ClientBox__3M2K-"};